// extracted by mini-css-extract-plugin
export default {"flyingImage":"ImageFlyPortal_flyingImage__oL-O3","fly-to-basket":"ImageFlyPortal_fly-to-basket__39KHQ"};